import React, { Component } from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone } from "react-bootstrap-table2-paginator";
import LoadMask from "../LoadMask/LoadMask";

export default class Grid extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Mostrando {to} de {size} resultados
        </span>
    );

    static defaultProps = {
        loading: false,
    };

    render() {
        const {
            loading,
            data = {
                results: [],
                count: 0,
            },
            page,
            hover = false,
            remote = true,
            expandableRow,
            expandComponent,
            cellEditProp,
            afterSave,
            onPageChange,
            onSortChange,
            pagination,
            expanding,
            onExpand,
            columns,
            sizePerPage = 10,
            trClassName,
            showPagination = true,
            rowClass = () => {
                return "";
            },
            ...other
        } = this.props;

        const paginateFactory = {
            custom: true,
            sizePerPage: sizePerPage,
            totalSize: data ? data.count : 0,
            page: page,
        };

        return (
            <div className="grid-container w-100">
                <LoadMask loading={loading} dark blur>
                    {showPagination ? (
                        <PaginationProvider pagination={paginationFactory(paginateFactory)}>
                            {({ paginationProps, paginationTableProps }) => (
                                <div className="pagination-provider-wrapper">
                                    <div className="table-responsive border-rounder">
                                        <BootstrapTable
                                            keyField="id"
                                            bodyClasses={"w-100"}
                                            data={data.results}
                                            columns={columns}
                                            hover={hover}
                                            rowClasses={rowClass}
                                            headerClasses={"header-table-blue"}
                                            remote={remote}
                                            trClassName={trClassName}
                                            onTableChange={(type, { page, sizePerPage, sortField, sortOrder }) => {
                                                if (type === 'pagination') {
                                                    onPageChange(page, sizePerPage);
                                                }
                                                if (type === 'sort') {
                                                    onSortChange && onSortChange(sortField);
                                                }
                                            }}
                                            {...paginationTableProps}
                                            {...other}
                                        />
                                    </div>
                                    <div className="pagination-footer d-flex justify-content-between align-items-center mt-3 px-3 pb-2">
                                        <PaginationTotalStandalone {...paginationProps} />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>
                                </div>
                            )}
                        </PaginationProvider>
                    ) : (
                        <div className="table-responsive border-rounder">
                            <BootstrapTable
                                keyField="id"
                                bodyClasses={"w-100"}
                                data={loading ? [] : data.results}
                                columns={columns}
                                hover={hover}
                                rowClasses={rowClass}
                                headerClasses={"header-table-blue"}
                                remote={remote}
                                trClassName={trClassName}
                                onTableChange={(type, { sortField }) => {
                                    if (type === 'sort') {
                                        onSortChange && onSortChange(sortField);
                                    }
                                }}
                                {...other}
                            />
                        </div>
                    )}
                </LoadMask>
            </div>
        );
    }
}
